<!-- 
<div class="stepper">
    <div class="logo-placeholder">
        <app-logo-placeholder [brand]="brand" [isPortraitDevice]="false"></app-logo-placeholder>
    </div>

    <div class="vertical-stepper">
        <app-vertical-step [steps]="steps" [stepNumberSelected]="stepNumberSelected"></app-vertical-step>
    </div>

    <div class="footer-vertical-stepper">
        <app-footer-vertical-step></app-footer-vertical-step>
    </div>
</div>
 -->

<div *ngIf="!isPortraitDevice && !isFinancialCartOpen" class="logo-marca">
    <app-logo-placeholder [brand]="brand" [isPortraitDevice]="isPortraitDevice"></app-logo-placeholder>
</div>

<div class="aside-navigation">
    <app-vertical-step [steps]="steps" [stepNumberSelected]="stepNumberSelected" [stepIdSelected]="stepIdSelected"></app-vertical-step>
</div>

<div class="footer-vertical-stepper">
    <app-footer-vertical-step></app-footer-vertical-step>
</div>
